import { appPermissions } from "../appPermissions";

export const isHasDynamicContentTypePermission = (id) => {
  var { isCanRead } = appPermissions.dynamicContentType(id);
  if (isCanRead) return true;
  return false;
};
